enum DatePickerMode {
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
  DECADES = 'decades',
}

export default DatePickerMode;

